import React from "react";
import styles from "./style.module.scss";
import useDomainStore from "../../../../../../../../../../stores/domain";

function GeneratedSign({ signedImages }) {
  const isKurvDomain = useDomainStore((state) => state.isKurvDomain);
  
  return (
    <div className={`${styles.selectSign} ${isKurvDomain ? styles.kurv_theme : ""}`}>
      <div className={styles.selectSignatureInner}>
        {signedImages?.signedName && <img src={signedImages?.signedName} />}
        {signedImages?.signedInitials && (
          <img src={signedImages?.signedInitials} />
        )}
      </div>
    </div>
  );
}

export default GeneratedSign;
